import React, { useState } from "react";

import { Button, Group, Stack, TextInput } from "@mantine/core";

interface MailChimpUpsellPaidSignupProps {
  cancel: () => void;
}

export function MailChimpUpsellPaidSignup({ cancel }: MailChimpUpsellPaidSignupProps): JSX.Element {
  const [emailValue, setEmailValue] = useState("");

  return (
    <form
      action="https://comprehensive.us6.list-manage.com/subscribe/post?u=5c59f28bbd0cfb8aa0fbccc42&id=8b3746988b&f_id=00b62fe3f0"
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
    >
      <input type="hidden" name="u" value="eb05e4f830c2a04be30171b01" />
      <input type="hidden" name="id" value="8281a64779" />
      <Stack gap={16}>
        <TextInput
          type="email"
          name="EMAIL"
          value={emailValue}
          onChange={(e) => setEmailValue(e.currentTarget.value)}
          autoCapitalize="off"
          autoCorrect="off"
          id="mce-EMAIL"
          size="sm"
          w="100%"
          required
          label="Business email address"
        />

        <Group grow>
          <Button onClick={cancel} variant="default" size="md">
            Cancel
          </Button>

          <Button
            type="submit"
            value="Subscribe"
            name="subscribe"
            id="mc-embedded-subscribe"
            size="md"
            variant="primary"
          >
            Join Waitlist
          </Button>
        </Group>
      </Stack>
      {/* <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--> */}
      <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
        <input
          type="text"
          name="b_5c59f28bbd0cfb8aa0fbccc42_8b3746988b"
          tabIndex={-1}
          value=""
          readOnly
        />
        <input type="hidden" name="tags" value="3310345" readOnly />
      </div>
    </form>
  );
}
